module.exports = __webpack_public_path__ + "img/product1.088bb6d3.png";